const Images = {
    image1 : require("./unequal-sa.jpg").default,
    image2 : require("./unequal-sa2.jpg").default,
    image3 : require("./unequal-sa3.jpg").default,
    image4 : require("./unequal-sa4.jpg").default,
}
export default Images;